import { type SyntheticEvent, useState } from 'react'
import styled from 'styled-components'
import { Body } from '@shipt/design-system-typography'
import { Button } from '@shipt/design-system-buttons'

type Context = 'cart' | 'order'
type Props = {
  onSubmit: (quantity: string) => void
  defaultValue?: number
  btnLabel?: string
  context: Context
  step?: number
  limit?: number
}

export const CustomQuantityForm = ({
  defaultValue = 1,
  btnLabel = 'Update',
  step = 1,
  limit = 999,
  context,
  onSubmit,
}: Props) => {
  const [value, setValue] = useState(defaultValue)

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault()
    onSubmit(value.toString())
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(Number(e.target.value))
  }

  const getButtonVariant = (orderContext: Context) => {
    if (orderContext === 'cart') {
      return 'primary'
    } else {
      return 'secondary'
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <FormInputs size="lg">
        <FormInput
          type="number"
          ref={(node) => {
            node?.focus()
          }}
          onChange={handleInputChange}
          aria-label={value.toString()}
          value={value.toString()}
          step={step}
          min="0"
          max={limit}
          aria-live="assertive"
        />
      </FormInputs>
      <Button type="submit" variant={getButtonVariant(context)} fullWidth>
        {btnLabel}
      </Button>
    </Form>
  )
}

const Form = styled.form`
  display: flex;
`

const FormInputs = styled(Body)`
  width: 30%;
  height: 3rem;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  margin-right: 1.5rem;
`

const FormInput = styled.input`
  caret-color: ${({ theme }) => theme.purple500};
  border-radius: 2px;
  width: 100%;
  height: 100%;
  padding: 8px;
  outline: none !important;
  border: 1px solid ${({ theme }) => theme.gray300};
`
